import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService } from "../../_services/common.service";
import { UserService } from '../../_services/user.service';
import { FlashMessagesService } from "angular2-flash-messages";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl
} from "@angular/forms";
export interface DialogData {
  group_id: string,
  name: string
}

@Component({
  selector: 'app-add-group',
  templateUrl: './add-group.component.html',
  styleUrls: ['./add-group.component.css']
})
export class AddGroupComponent implements OnInit {
  addGroupForm: FormGroup;
  Options = {};
  public title: string;
  private result = '';
  public activeClass: string;
  public selectedFile = [];
  public msgClass: string;
  public msg: string;
  public isShowMsg = false;
  imageUrl = [];
  //colorName = [''];
  //colorImage = [''];
  defaultColorData = [
    {
      colorId: '0',
      colorName: '',
      colorImage: ''
    }
  ]


  ColorFamilyList: Array<any> = [];
  colorList: Array<any> = [];

  constructor(private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<AddGroupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private CommonService: CommonService,
    private userService: UserService,
    private _flashMessagesService: FlashMessagesService) { }

  ngOnInit() {
    this.title = "Add Group and Colors";
    this.addGroupForm = this.formBuilder.group({
      groupName: [null, Validators.required],
      coloFamilyId: [null]
      // Colors:this.formBuilder.array([this.addColoritems()])
    });
    if (this.data.group_id) {
      this.title = "Update Group and Colors";
      this.addGroupForm.get("groupName").patchValue(this.data.name);
      this.activeClass = 'active';
      this.getColorList();
    }
    else {
      this.addGroupForm.get("coloFamilyId").setValidators(Validators.required);
      this.getColorFamilyList();
    }

  }

  getColorFamilyList = function () {
    this.userService.getColorList().subscribe((response: any) => {
      if (response.status === true) {
        let data = response.data.filter(x => x.type === 'custom');
        if (data)
          this.ColorFamilyList = data;
      }

    },
      (err) => {

      });


  }

  getColorList = function () {
    this.CommonService.apiService(
      "GET",
      "colors/" + this.data.group_id
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data) {
            //this.colorList = response.data;
            //this.colorName=[];
            //this.colorImage=[];
            this.defaultColorData = [];
            response.data.forEach((element, index) => {
              this.defaultColorData.push({
                colorId: element.color_id,
                colorName: element.name,
                colorImage: ''
              });
              console.log('defaultColorData', this.defaultColorData);
              this.imageUrl.push(element.image);
              this.selectedFile.push('');
              //this.colorImage.push('');
            });

          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }


  addColoritems() {
    return this.formBuilder.group({
      colorName: [null, Validators.required],
      colorImage: [null, Validators.required]
    });
  }

  onFileChanged(event, index) {
    console.log('imageUrl', this.imageUrl);
    console.log('index', index);
    if (this.data.group_id)
      this.selectedFile[index] = event.target.files[0];
    else
      this.selectedFile.push(event.target.files[0]);

    var render = new FileReader();
    render.onload = (event: any) => {
      if (this.data.group_id) {
        this.imageUrl[index] = event.target.result;
        console.log('in edit imageUrl', this.imageUrl);
      }
      else {
        this.imageUrl.push(event.target.result);
      }

      //alert(event.target.result);     
    }
    render.readAsDataURL(event.target.files[0]);
    console.log('selected file', this.selectedFile);
  }

  addColorRow(index) {
    //let totalcount=this.defaultColorData.length.toString();
    //console.log('tconut',totalcount);
    this.defaultColorData.push({
      colorId: index,
      colorName: '',
      colorImage: ''
    });
    console.log('Defaultdata', this.defaultColorData);
  }

  deleteColorRow(index) {
    if (this.defaultColorData.length > 1) {
      if (this.data.group_id) {        
        this.deleteColor(this.defaultColorData[index].colorId);
      }
      this.defaultColorData.splice(index, 1);
      this.selectedFile.splice(index, 1);
      this.imageUrl.splice(index, 1);

    }
  }

  deleteColor = function (id) {
    this.msgClass = "";
    this.msg = "";
    this.isShowMsg=false;
    let attributeOptions = {
    };
    this.CommonService.apiService(
      "DELETE",
      "color/delete/" + id + "/" + localStorage.getItem("userID"),
      attributeOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          // this._flashMessagesService.show(response.message, {
          //   cssClass: "alert-success",
          //   timeout: 5000
          // });
          this.msg = response.message;
          this.msgClass = "alert-successs"
          this.isShowMsg = true;
          setTimeout(function () {
            this.isShowMsg = false;
          }.bind(this), 5000);


        }
      },
      err => {
        // this._flashMessagesService.show(err.error.message, {
        //   cssClass: "alert-danger",
        //   timeout: 5000
        // });
        this.msg = err.error.message;
        this.msgClass = "alert-danger";
        this.isShowMsg=true;
        setTimeout(function () {
          this.isShowMsg = false;
        }.bind(this), 5000);

      }
    );
  }

  SaveColor = function (postData) {
    this.msg = "";
    this.msgClass = "";
    this.isShowMsg=false;
    const formData = new FormData();
    formData.append('name', postData.groupName);
    let apiName = 'group/create';
    //if (this.defaultColorData.colorName.indexOf('') == -1) {
    let errormsg = '';
    if (this.data.group_id) {
      apiName = 'group/edit';
      formData.append('shop_id', localStorage.getItem("userID"));
      formData.append('id', this.data.group_id);
      this.defaultColorData.forEach((element, index) => {
        if (this.selectedFile.length > 0) {
          if (this.selectedFile[index] != null && this.selectedFile[index] != '') {
            formData.append("image[" + element.colorId + ']', this.selectedFile[index], this.selectedFile[index].name);
          }
          else {
            formData.append("image[" + element.colorId + ']', '');
          }
        }
        else {
          formData.append("image[" + element.colorId + ']', '');
        }
        if (element.colorName != null && element.colorName != '') {
          formData.append('colors[' + element.colorId + ']', element.colorName);
        } else {
          errormsg = "Please enter color name";
        }

      })
    }
    else {
      this.defaultColorData.forEach((element, index) => {
        if (this.selectedFile[index] != null && this.selectedFile[index] != '') {
          formData.append("image[]", this.selectedFile[index], this.selectedFile[index].name);
        }
        else {
          errormsg = "Please upload color image";

        }
        if (element.colorName != null && element.colorName != '') {
          formData.append('colors[]', element.colorName);
        } else {
          errormsg = "Please enter color name";
        }

      })
      formData.append('id', localStorage.getItem("userID"));
      formData.append('family_id', postData.coloFamilyId);
    }
    if (errormsg != '') {
      // this._flashMessagesService.show(errormsg, {
      //   cssClass: "alert-danger",
      //   timeout: 2000
      // });
      this.msg = errormsg;
      this.msgClass = "alert-dangerr";
      this.isShowMsg = true;
      setTimeout(function () {
        this.isShowMsg = false;
      }.bind(this), 5000);

      return;
    }

    this.CommonService.apiService(
      "POST",
      apiName,
      formData
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.result = "success";
          this.dialogRef.close(this.result);
        }
        window.scrollTo(0, 0);
      },
      err => {
        // this._flashMessagesService.show(err.error.message, {
        //   cssClass: "alert-danger",
        //   timeout: 5000
        // });
        this.msg = err.error.message;
        this.msgClass = "alert-dangerr";
        this.isShowMsg = true;
        setTimeout(function () {
          this.isShowMsg = false;
        }.bind(this), 5000); 

      }
    );
  }

  onNoClick(): void {
    this.dialogRef.close(this.result);
  }

  trackByFn(index: any, item: any) {
    return index;
  }



}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-products/add-group/add-group.component.ts